// ShroomLuxe theme JS
document.documentElement.classList.remove('no-js');
document.addEventListener('click', function(e){
  var t = e.target.closest('[data-nav-toggle]');
  if(t){ var h = t.closest('[data-header]'); if(h){ h.classList.toggle('nav-open'); } }
  var sub = e.target.closest('.hnav.has-sub > a');
  if(sub && window.matchMedia('(max-width:900px)').matches){ e.preventDefault(); sub.parentNode.classList.toggle('open'); }
});
